import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component to scroll to the top of the page
 * when navigating between routes using React Router.
 * Note: This component expects `react-router-dom v6`.
 **/
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const storedScroll = useRef([]);

  useEffect(() => {
    // Store the current scroll position for the current pathname
    const currentIndex = storedScroll.current.findIndex(item => item[0] === pathname);
    
    if (currentIndex === -1) {
      // If pathname is new, push it with scroll position 0
      storedScroll.current.push([pathname, 0]);
    } else {
      // If pathname exists, update its scroll position to 0
      storedScroll.current[currentIndex][1] = 0;
    }

    // Scroll to the top
    window.scrollTo({
      top: 0,
      behavior: "instant", // or "smooth" for a smooth scroll effect
    });

    // Listen to the scroll event to update the stored scroll value of the current pathname
    const onScroll = () => {
      const index = storedScroll.current.findIndex(item => item[0] === pathname);
      if (index !== -1) {
        storedScroll.current[index][1] = window.scrollY;
      }
    };

    window.addEventListener("scroll", onScroll);
    
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop;
